import React, { useState } from "react";
import { useDispatch } from "react-redux";
import { Button, Form, Input, message } from "antd";

import AuthAPI from "../../api/AuthAPI";
import { setUserAccount } from "../../redux/reducers/userAccountSlice";

import "./signin.styles.css";

const SignIn = () => {
  const [isLoading, setLoading] = useState(false);
  const [messageApi, contextHolder] = message.useMessage();
  const dispatch = useDispatch();
  const [form] = Form.useForm();

  const onFinish = async (values) => {
    setLoading(true);
    try {
      const response = await AuthAPI.authUser(values.username, values.password);
      const authResponse = response.data;

      if (!authResponse.success) {
        messageApi.open({
          type: "error",
          content: authResponse.message,
        });
        setLoading(false);
        return;
      }

      messageApi.open({
        type: "success",
        content: authResponse.message,
      });
      setLoading(false);
      const user = {
        token: authResponse.token,
        id: authResponse.userId,
        name: authResponse.userName,
      };
      dispatch(setUserAccount(user));
    } catch (ex) {
      console.error("Servicio no disponible, intente más tarde. " + ex.message);
      let message = "Servicio no disponible, intente más tarde. ";

      if (ex.code !== "ERR_NETWORK") {
        message = ex.response.data.message;
      }

      messageApi.open({
        type: "error",
        content: message,
      });
      setLoading(false);
      form.resetFields();
    }
  };

  return (
    <div className="sign-in">
      {contextHolder}
      <div>
        <Form
          name="sign-in-form"
          layout="vertical"
          form={form}
          onFinish={onFinish}
          className="signin-form"
        >
          <img width="400px" src="/awm_logo_dark.png" alt="AWM Logo" />
          <h1>Integrated Security Admin</h1>
          <h2>Login</h2>
          <Form.Item name="username" label="USUARIO">
            <Input type="text" required />
          </Form.Item>
          <Form.Item name="password" label="PASSWORD">
            <Input type="password" required />
          </Form.Item>
          <div className="button-group">
            <Button htmlType="submit" type="primary" loading={isLoading}>
              ACCEDER
            </Button>
          </div>
        </Form>
      </div>
    </div>
  );
};

export default SignIn;
